import React from "react";
import clsx from "clsx";
import { Draggable } from "react-beautiful-dnd";
import DragItem from "./DragItem";

function DraggablesWrapper({
  items,
  getItemStyle,
  warnEdit,
  handleItemClick,
  route,
  setConfirmDialogState,
  projectId,
  projectStatus,
  handleMouseEnter,
  handleMouseLeave,
  color,
  selectedStops,
  handleSelect,
  countStart,
  disableDrag,
  setDragSelectionByArr
}) {
  let count = 0;
  let daysPassed = false;
  let indexToSet = 0;
  return items
    .filter(el => el.type !== "start" && el.type !== "end")
    .map((item, index) => {
      if (item.type !== "break") count++;
      let number = count;
      if (item.days_on_the_road >= 1) {
        daysPassed = true;
      }
      let daysPassedInner = daysPassed;

      return (
        <Draggable
          key={item.id}
          draggableId={item.id}
          index={indexToSet++}
          isDragDisabled={
            item.status === "finished" ||
            item.status === "skipped" ||
            disableDrag
          }
        >
          {(provided, snapshot) => (
            <div
              ref={provided.innerRef}
              {...provided.draggableProps}
              {...provided.dragHandleProps}
              style={getItemStyle(
                snapshot.isDragging,
                provided.draggableProps.style,
                index
              )}
              onClick={e => {
                // Allow edit only stops not breaks
                item.type !== "break" &&
                  warnEdit(e, item.id, item.type, undefined, item.status);
                e.preventDefault();
                /*
                item.status === "finished" || item.status === "skipped"
                  ? e => warnEdit(e, item.id, item.type, undefined, item.status)
                  : handleItemClick(`route-${route.id}`, item.id, item.type)*/
              }}
            >
              <DragItem
                item={item}
                index={index}
                editStop={warnEdit}
                deleteStop={setConfirmDialogState}
                container
                count={countStart + number}
                alignItems="center"
                className={clsx("drag-item", [
                  { "is-dragging": snapshot.isDragging }
                ])}
                startedRoute={route.stops[0].status === "finished"}
                daysPassed={daysPassedInner}
                routeStatus={route.status}
                isDragging={snapshot.isDragging}
                projectStatus={projectStatus}
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
                projectId={projectId}
                color={color}
                handleSelect={handleSelect}
                selected={selectedStops.includes(item.id)}
                hasSelected={selectedStops.length > 0}
              />
            </div>
          )}
        </Draggable>
      );
    });
}

export default DraggablesWrapper;
